// extracted by mini-css-extract-plugin
module.exports = {"content":"style-module__content___s22tr","welcome":"style-module__welcome___zrYB0","headline":"style-module__headline___VwewO"};